module.exports = __webpack_public_path__ + "img/webhook.27fd048e.svg";